import { Injectable } from '@angular/core';
import type { CellValue } from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  /**
   * Converts an Excel file to a 2D array.
   * @param file The Excel file to read
   * @param sheetNumber The sheet index (0-based)
   * @returns Promise resolving to a 2D array representation of the sheet
   */
  async fileToJson(file: File, sheetNumber: number = 0): Promise<CellValue[][]> {
    const ExcelJS = await import('exceljs');
    const workbook = new ExcelJS.default.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const worksheet = workbook.worksheets[sheetNumber];

    if (!worksheet) {
      throw new Error(`Worksheet ${sheetNumber} not found.`);
    }

    const rows: CellValue[][] = [];

    worksheet.eachRow({ includeEmpty: true }, (row) => {
      const rowValues = row.values;

      if (Array.isArray(rowValues)) {
        // row.values is 1-based, so remove the unused first element.
        rows.push(rowValues.slice(1));
      } else {
        rows.push(Object.values(rowValues));
      }
    });

    return rows;
  }
}